import { Injectable } from '@angular/core';
import { IExternalEntities } from './iexternal-entities';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';
import { BaseRespone } from 'src/app/models/common.response';
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ExternalEntitiesService {

  private _externalEntities: BehaviorSubject<IExternalEntities | null> = new BehaviorSubject<IExternalEntities | null>(null);

  constructor(
    private _httpClient: HttpClient
  ) { }

  createExternalEntities(entity: FormData): Observable<BaseRespone<IExternalEntities>> {
    return this._httpClient.post<BaseRespone<IExternalEntities>>(`${environment.baseURl}/ExternalEntities`, entity)
      .pipe(
        catchError((error) => {
          return of(error.error);
        }),
        map((newentity) => {
          // Return the new entity
          return newentity;
        })
      )
  }
}
